export const getActiveState = (states) => {
  const activeState = Object.entries(JSON.parse(states)).filter(
    (item) => item[1].active === 1
  );
  if (activeState.length === 0) return null;
  return activeState[0][0];
};

export const isCorrectLink = (str) => {
  try {
    return !!new URL(str);
  } catch (_) {
    return false;
  }
};
